import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 border border-foreground-300/40 rounded-full text-foreground-500 text-xs font-medium tracking-wide mb-6">
          {t('about.badge')}
        </span>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-light text-foreground-950 leading-tight mb-10 md:mb-14">
          {t('about.title.line1')}
          <br />
          <span className="relative inline-block">
            {t('about.title.line2')}
            <span className="absolute -bottom-1 left-0 right-0 h-4 bg-primary-200/60 -z-10 rounded-sm"></span>
          </span>
          {' '}{t('about.title.line3')}
        </h2>

        <article className="text-left space-y-5">
          <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
            <strong className="text-foreground-900 font-semibold">Kakobuy Spreadsheet</strong> {t('about.paragraph1')}
          </p>
          <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
            {t('about.paragraph2')}
          </p>
        </article>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex flex-col items-center gap-3 p-5 bg-background-100 rounded-2xl">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full">
                <i className={`${['ri-shield-check-line', 'ri-links-line', 'ri-star-line', 'ri-lock-unlock-line'][i - 1]} text-lg`}></i>
              </div>
              <span className="text-foreground-700 text-xs md:text-sm font-medium text-center">
                {t(`about.trust.item${i}`)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}